import { Component, Input } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-collab-invite-modal',
  templateUrl: './collab-invite-modal.component.html',
  styleUrls: ['./collab-invite-modal.component.scss'],
})
export class CollabInviteModalComponent {
  @Input() acceptCb: () => void;
  @Input() rejectCb: () => void;
  @Input() session: Session;
  @Input() idea: Idea;

  constructor(
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,
  ) {}

  accept() {
    this.acceptCb();
    this.activeModal.close();
  }

  reject() {
    this.rejectCb();
    this.activeModal.close();
  }
}
